import { fabric } from "fabric";

const cancelRequestAnimFrame = (() =>
  window.cancelAnimationFrame || clearTimeout)();

export default class RenderingHandler {
  static _rafMap = {};

  static startRepaintingCanvas = (canvas) => {
    if (!canvas || !("requestRenderAll" in canvas)) {
      return;
    }

    const canvasId = canvas.getElement().id;
    if (canvasId in RenderingHandler._rafMap) {
      return;
    }


    const render = () => {
      canvas.requestRenderAll();
      RenderingHandler._rafMap[canvasId] = fabric.util.requestAnimFrame(render);
    };

    RenderingHandler._rafMap[canvasId] = fabric.util.requestAnimFrame(render);
  };

  static stopRepaintingCanvas = (canvas) => {
    if (!canvas) {
      return;
    }

    const canvasId = canvas.getElement().id;
    if (!(canvasId in RenderingHandler._rafMap)) {
      return;
    }

    cancelRequestAnimFrame(RenderingHandler._rafMap[canvasId]);
    delete RenderingHandler._rafMap[canvasId];
  };
}
